import React from 'react';
import {Dropdown} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {I18n} from "../../../i18n/KiloITi18n";

const IframeDropdownMobileMenu = () => {

    const navigate = useNavigate();
    const param = useParams();
    const tableId = parseInt(param.id ?? "0");


    return (
        <Dropdown className="bg-transparent p-1">
            <Dropdown.Toggle className="bg-transparent">
                <i className="bi bi-list fs-1 text-light"/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="bg-light">
                <Dropdown.Item onClick={() => navigate(`/lobby/${tableId}/statement`)}
                               className="border-bottom text-dark fw-bold fs-6 py-4 d-none">
                    <i className="bi bi-ticket text-warning fs-2 me-4"/>
                    <span><I18n t={"TICKET"}/></span>
                </Dropdown.Item>

                <Dropdown.Item onClick={() => navigate(`/app-report/${tableId}`)}
                               className="border-bottom text-dark fw-bold fs-6 py-4">
                    <i className="fa-solid fa-file-text text-warning fs-2 me-4"/>
                    <span><I18n t={"REPORT"}/></span>
                </Dropdown.Item>

                <Dropdown.Item onClick={() => navigate(`/app-result/${tableId}`)}
                               className="border-bottom text-dark fw-bold fs-6 py-4">
                    <i className="fa-solid fa-square-poll-horizontal fs-2 me-4"/>
                    <span><I18n t={"RESULT"}/></span>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default IframeDropdownMobileMenu;